<template>
    <div></div>
</template>
<script>
export default {
    name: 'MasivaGuia',
    props:['reciveitem','accion'],
    data() {
        return {
            preitem: {},
            items:[]
        }
    },
    mounted() {
        this.initPreItem()
    },
    watch:{
        'accion.i': function () {
                if(this.accion.i){   
                    for( let i = 0; i<this.reciveitem.length; i++){ 
                        this.completeItem(i)
                    }
                }          
            },
        'accion.reset': function () {
                if(this.accion.reset){
                    this.items = []
                }   
            }  
    },
    methods: {
        initPreItem(){
            this.preitem={
                numero:'',
                tipo:''
            }
        },
        completeItem(i){
            if(this.reciveitem){
                this.preitem.numero = this.reciveitem[i].serie + "-" + this.reciveitem[i].numero
                if(this.reciveitem[i].tipoGuia == "Guia Remision Remitente" || this.reciveitem[i].tipoGuia == 1){
                    this.preitem.tipo = "09"
                }else if(this.reciveitem[i].tipoGuia == "Guia Remision Transportista" || this.reciveitem[i].tipoGuia == 2){
                     this.preitem.tipo = "31"
                }
            this.items.unshift(this.preitem)
            this.initPreItem()
            this.getItems(this.items) 
            }
        },
        getItems(data){
            this.$emit("totalitems2",data)
        }
    },
    
}
</script>